import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import styles from "../styles/WorkflowDetailsPage.module.css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Waldiez, importFlow } from "@waldiez/react";
import "@waldiez/react/dist/@waldiez.css";
import { getWorkflowById, getWorkflowDownloads } from "../api/api";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const WorkflowDetailsPage = () => {
  const { id } = useParams();
  const [workflow, setWorkflow] = useState(null);
  const [flow, setFlow] = useState(null);
  const [workFlowDownloads, setWorkFlowDownloads] = useState([]);

  useEffect(() => {
    const fetchWorkflow = async () => {
      try {
        const foundWorkflow = await getWorkflowById(id);
        const workFlowMonthlyDownloads = await getWorkflowDownloads(id);
        setWorkflow(foundWorkflow);
        setWorkFlowDownloads(workFlowMonthlyDownloads);
        const flow = importFlow(foundWorkflow);
        setFlow(flow);
      } catch (error) {
        console.error("Error fetching workflow:", error);
      }
    };

    fetchWorkflow();
  }, [id]);

  const calculateMonthlyDownloads = () => {
    const downloads = Array.from(workFlowDownloads, (element, _) => {
      return element.downloads;
    });
    const totalDownloads = downloads.reduce((acc, curr) => acc + curr, 0);
    return totalDownloads;
  };

  // Example data for the chart
  const chartData = {
    labels: Array.from(
      { length: workFlowDownloads.length },
      (_, i) => `${i + 1}`
    ), // Last 30 days
    datasets: [
      {
        label: "Downloads",
        data: Array.from(workFlowDownloads, (element, index) => {
          return element.downloads;
        }),
        borderColor: "#cb95fa",
        borderWidth: 2,
        fill: false, // Only show the line
        tension: 0.4, // Smooth line
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide legend
      },
      tooltip: {
        enabled: false, // Hide tooltip
      },
    },
    scales: {
      x: {
        display: false, // Hide x-axis
      },
      y: {
        display: false, // Hide y-axis
      },
    },
    elements: {
      point: {
        radius: 0, // Hide data points
      },
    },
  };

  if (!workflow) {
    return <div></div>;
  }

  return (
    <div className={styles.workflowDetailsPage}>
      <div className={styles.secondRow}>
        <div className={styles.workflowCardContent}>
          {/* Left Column */}
          <div className={styles.leftColumn}>
            <ReactMarkdown>{workflow.description}</ReactMarkdown>
          </div>
          {/* Right Column */}
          <div className={styles.rightColumn}>
            <div className={`${styles.rightColumnSection} ${styles.small}`}>
              <h3>Downloads last month</h3>
              <p className={styles.downloadCount}>
                {calculateMonthlyDownloads()}
              </p>
            </div>

            <div className={`${styles.rightColumnSection} ${styles.large}`}>
              <div className={styles.chartWrapper}>
                <Line
                  key={JSON.stringify(chartData)}
                  data={chartData}
                  options={chartOptions}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.flowWrapper}>
          <Waldiez
            className={styles.flow}
            flowId={flow.id}
            name={flow.name}
            storageId={flow.storageId ?? flow.id}
            description={flow.description}
            requirements={flow.requirements}
            tags={flow.tags}
            edges={flow.edges}
            nodes={flow.nodes}
            viewport={flow.viewport}
            onChange={null}
            monacoVsPath={undefined}
            onRun={null}
            onUpload={null}
            readOnly={false}
            skipExport={true}
            skipImport={true}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkflowDetailsPage;
